import { Button, ButtonVariant, Modal } from "shared/components";
import { InfoCircle } from "untitledui-js-base";
import { User } from "../types";
import { FC } from "react";

type Props = {
  user: User | undefined;
  opened?: boolean;
  onClose: () => void;
  onRemove: () => void;
};

export const RemoveUserModal: FC<Props> = ({
  opened,
  user,
  onClose,
  onRemove
}) => {
  return (
    <Modal
      opened={opened ?? Boolean(user)}
      onClose={onClose}
      panelClassName="w-[366px] items-center p-6 flex flex-col"
    >
      <div className="mb-4 rounded-full bg-danger-50 p-4">
        <InfoCircle className="stroke-danger-500" size="32" />
      </div>
      <h2 className="text-xl font-bold text-content-1000 mb-2 text-center">
        Are you sure you want remove {user?.name}?
      </h2>
      <p className="text-content-500 text-sm mb-4">
        They won&apos;t be able to access the platform
      </p>
      <div className="flex w-full gap-2">
        <div className="w-full">
          <Button onClick={onClose} className="w-full">
            Cancel
          </Button>
        </div>
        <div className="w-full">
          <Button
            onClick={() => {
              onRemove();
            }}
            variant={ButtonVariant.DANGER}
            className="w-full"
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};
